import React from 'react';
import { Box, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';

import { COLOURS } from 'clipsal-cortex-utils/src/constants/colors';

import { Circuit } from '../../../../../api/api-device';
import { SHORT_DATA_TYPE_TO_TITLE_MAP } from '../meter-config-constants';
import { getCircuitDisplayName } from '../meter-config-helpers';
import { ShortPowerDataType, ShortPowerDataTypeToSeries } from '../meter-config-types';
import { useAssignments } from '../meterConfigApi';

type ShortEnergyTableProps = {
  circuits: Circuit[];
  onToggleLine: (channelIndex: number) => void;
  hiddenIndexes: number[];
  shortChartData: ShortPowerDataTypeToSeries;
};

export const ShortEnergyTable = ({ circuits, shortChartData, onToggleLine, hiddenIndexes }: ShortEnergyTableProps) => {
  const { assignments } = useAssignments();
  return (
    <TableContainer
      bg={'white'}
      _dark={{ bg: 'gray.900' }}
      w="100%"
      border={'1px solid'}
      borderColor={'gray.200'}
      borderRadius={8}
      data-testid="short-energy-table"
    >
      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>Circuit Name</Th>
            <Th>Circuit Id</Th>
            <Th>Circuit Type</Th>
            {Object.values(SHORT_DATA_TYPE_TO_TITLE_MAP).map((label) => (
              <Th key={label} textAlign={'center'}>
                {label}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {circuits.map((circuit, index) => {
            return (
              <Tr
                cursor="pointer"
                _hover={{ bg: 'gray.100' }}
                _dark={{ _hover: { bg: 'gray.700' } }}
                opacity={hiddenIndexes.includes(index) ? 0.3 : 1}
                onClick={() => onToggleLine(index)}
                key={`live-table-row-${circuit.id}`}
              >
                <Td py={2}>
                  <Flex align="center">
                    <Box background={COLOURS[index]} h={4} w={4} rounded={4} />
                    <Text ml={2}>
                      {circuit.circuit_name} (CH {index + 1})
                    </Text>
                  </Flex>
                </Td>
                <Td py={2}>{circuit.oem_circuit_id}</Td>
                <Td py={2}>{getCircuitDisplayName(circuit, assignments)}</Td>

                {Object.keys(SHORT_DATA_TYPE_TO_TITLE_MAP).map((key) => {
                  const latestData = shortChartData[key as ShortPowerDataType]?.data[index]?.data;
                  const value = latestData?.[latestData?.length - 1]?.y ?? 0;
                  return (
                    <Td key={key} textAlign={'center'} py={2}>
                      {value.toFixed(2)}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
